module.exports = "<button type=\"button\" class=\"btn btn-secondary\" (click)=\"previous()\" [disabled]=\"!hasPreviousPage || loading\">\n  Föregående\n</button>\n<div class=\"\">\n  Sidan {{ paginator.currentPage }} av {{ paginator.totalPages }} ({{ paginator.total }} träffar)\n</div>\n<button type=\"button\" class=\"btn btn-secondary float-right\" (click)=\"next()\" [disabled]=\"!hasNextPage || loading\">\n  Nästa\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pagination/pagination.component.html
// module id = ./src/app/shared/pagination/pagination.component.html
// module chunks = main